import { useCheckAwbService } from '../service/check-awb';

export function useAwb() {
  const { check } = useCheckAwbService();

  function checkAwb(awbNumber: string) {
    return check(awbNumber);
  }

  return {
    checkAwb,
  };
}

export default useAwb;
